import { BASE_URL, EMPLOYEE_URL } from '../constants'
import { apiSlice } from './apiSlice'

export const commonApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getOptions: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        GetEmployeeList: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        getReportTypes: builder.mutation({
            query: (formData) => ({
                url: EMPLOYEE_URL,
                method: 'POST',
                body: formData,
            }),
        }),

    }),
})

export const { useGetOptionsMutation, useGetEmployeeListMutation, useGetReportTypesMutation } = commonApiSlice